import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import '../entrypoints/application.css'

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.tsx')
    const match = pages[`../pages/${name}.tsx`]
    if (!match) {
      throw new Error(`Inertia page not found: ${name}`)
    }
    return match()
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
